import { Platform } from 'react-native';

const log_facebook_event = (event_name) => {
  log_web_event(event_name);
  log_mobile_event(event_name);
}

const log_mobile_event = async (event_name) => {
  if (Platform.OS === 'web') {
    return;
  }

  let FBSDK = require("react-native-fbsdk-next");
  let PERMS = require("react-native-permissions");
  let { PERMISSIONS, RESULTS, request } = PERMS;
  let { Settings, AppEventsLogger }     = FBSDK;

  Settings.initializeSDK();

  if(Platform.OS === 'ios') {
    const requestResult = await request(PERMISSIONS.IOS.APP_TRACKING_TRANSPARENCY);
    Settings.setAdvertiserTrackingEnabled(requestResult === RESULTS.GRANTED)
  }

  switch (event_name) {
    case 'PageView':
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.ViewedContent, { [AppEventsLogger.AppEventParams.ContentType]: "HomePage" })
      break;
    case 'Subscribe':
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.Subscribe, { [AppEventsLogger.AppEventParams.Currency]: "usd" })
      break;
    case 'CompleteRegistration':
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.ViewedContent, { [AppEventsLogger.AppEventParams.RegistrationMethod]: "email" })
      break;
    case 'Purchase':
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.Purchased, { [AppEventsLogger.AppEventParams.Currency]: "usd" })
      break;
    default:

  }

  AppEventsLogger.flush()
}

const log_web_event = (event_name) => {
  if (Platform.OS === 'web') {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

     fbq('init', '1421996844904147');
     fbq('track', event_name);
 }
}

export default {
  log_facebook_event
}
